import { useMutation } from '@reverbdotcom/commons/src/useMutation';

import { gql } from '@apollo/client';
import { CoreListingUpdateState } from '@reverbdotcom/commons/src/gql/graphql';

const updateListingStateMutation = gql`
  mutation Core_Listing_UpdateState(
    $input: Input_core_apimessages_UpdateListingStateRequest
  ) {
    updateListingState(input: $input) {
      newState
    }
  }
`;

export function useUpdateListingStateMutation() {
  return useMutation<CoreListingUpdateState.Mutation, CoreListingUpdateState.Variables>(updateListingStateMutation);
}
